import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, NgModule, OnInit, Output } from '@angular/core';
import { Answer, Question } from '@domains/cej-v2/cej-v2-form/cej-orientation-graph';
import { trackEventWithAtInternet } from '@wizbii/tracking';

@Component({
  selector: 'app-cej-multiple-choices-question',
  templateUrl: './cej-multiple-choices-question.component.html',
  styleUrls: ['./cej-multiple-choices-question.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejMultipleChoicesQuestionComponent implements OnInit {
  @Input() question!: Question;
  @Input() displayReturn!: boolean;

  @Output() submittedAnswers: EventEmitter<string[]> = new EventEmitter();
  @Output() return: EventEmitter<string | null> = new EventEmitter();

  answers!: Array<Answer & { selected: boolean }>;
  trackEvent = trackEventWithAtInternet;

  ngOnInit(): void {
    this.answers = this.question.answers.map((answer) => ({ ...answer, selected: false }));
  }

  clickAnswer(value: string): void {
    const clickedAnswer = this.answers.find((answer) => answer.value === value);
    if (clickedAnswer) {
      clickedAnswer.selected = !clickedAnswer.selected;
      this.trackEvent({ category: 'CEJ', ...clickedAnswer.trackEvent });
    }
  }

  clickReturn(trackEventLabel?: string): void {
    this.return.emit(trackEventLabel);
  }

  clickValidate(): void {
    this.question?.trackEventAction &&
      this.trackEvent({ category: 'CEJ', action: this.question.trackEventAction, type: 'action' });
    const submittedAnswers = this.answers.filter((answer) => answer.selected).map((answer) => answer.value);
    this.submittedAnswers.emit(submittedAnswers);
  }

  trackByAnswer(_: number, answer: Answer): string {
    return answer.value;
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [CejMultipleChoicesQuestionComponent],
  exports: [CejMultipleChoicesQuestionComponent],
})
export class CejMultipleChoicesQuestionModule {}
